/**Import store section */
import { hasAuthorization } from '../../../store/session/sessionActions'
/**Import resources section */
import { IMBERA_TECHNICIAN, PORTAL_ADMINISTRATOR, SPARE_PARTS_IMBERA_USA } from '../../../resources/RolesEnum'

/**
 * Roles that may act on a closed request (Closed or Cancelled): cancel a request closed by mistake,
 * delete a cancelled one (IS2-45).
 */
export const CLOSED_REQUEST_ROLES = [PORTAL_ADMINISTRATOR, SPARE_PARTS_IMBERA_USA]

/**
 * Whether the internal "Change status" control is shown for a sales request.
 *
 * An open request keeps the rule it always had: Imbera Technician only. A closed one (the backend
 * reports IsClosed for Closed and Cancelled alike) is offered to administrators and Imbera USA, but
 * only when the backend publishes an operation for it. Which transitions exist is the backend's
 * decision; requiring at least one keeps the control from opening an empty panel, and keeps this
 * rule harmless while the backend has not published the new transitions yet.
 *
 * @param {object} request the open request, as plain JS
 * @param {object} userProfile the session profile
 */
export const canChangeInternalStatus = (request, userProfile) => {
	if (!request) return false
	if (!request.IsClosed) return hasAuthorization(userProfile, [IMBERA_TECHNICIAN])
	const hasOperations = Array.isArray(request.AvailableOperations) && request.AvailableOperations.length > 0
	return hasOperations && hasAuthorization(userProfile, CLOSED_REQUEST_ROLES)
}
